// BatStateEngine.js
//
// FE Engine Pattern V2 (rk=beeca47db94541d594bc4aa830f62672) — initial REST fetch
// (all states in one call) plus live SignalR push (OnPowerStateUpdated),
// both write to BatStateCache, overwritten per rk. Singleton.
import { events } from '@/services/wss/SystemEvents';
import ComponentNotifier from '../../../services/wss/ComponentNotifier';
import WssEventHandlerBase from '@/services/engines/WssEventHandlerBase';
import batStateCache from './BatStateCache';
import batStateFetcher from './BatStateFetcher';

const _name = 'BatStateEngine';

class BatStateEngine extends WssEventHandlerBase {
    _name = _name;

    bootup() {
        super.bootup();
        this.clear();

        this._unsub = this._wsNotifier.subscribe(events.OnPowerStateUpdated, this.onMessage);
    }

    clear() {
        super.clear();
        if (this._unsub) this._unsub();
    }

    /**
     * BE push — 1 battery state per message, overwrites the cached state for that rk.
     * @param  data = ALWAYS AN ARRAY HENKIE
     */
    onMessage = (data) => {
        try {
            batStateCache.addOrUpdate(data);
            this._notify(data.rk);
        } catch (error) {
            this.logError('onMessage', error.message);
        }
    };

    /**
     * Initial fetch — all battery states in one call. Live updates come via onMessage.
     * @returns {Promise<object[]>}
     */
    fetch = async () => {
        try {
            const states = await batStateFetcher.fetch();
            batStateCache.addOrUpdate(states);

            this._notify();
            return states;
        } catch (error) {
            this.logError('fetch', error.message);
            return [];
        }
    };

    /**
     * @param {string} [rk] - undefined on the initial batch fetch
     */
    _notify = (rk) => {
        ComponentNotifier.notify(_name, 'dataChanged', { rk });
    };
}

const batStateEngine = new BatStateEngine();
export default batStateEngine;
